import { Button, Input } from "../../../../../components/ui";
import { getPaymentTypeName, maskAccountNumber } from "../../../../../helpers/getText";
import user from "../../../../../assets/images/single_bill.svg";
import onoPayout from "../../../../../assets/images/ono_payout.svg";
import { getCurrencyNumberWithSymbol, getMaskedMobileNumber, numberToWordsWithDecimals } from "../../../../../helpers/get-currency-number";
import moment from "moment";
import { useSelector } from "react-redux";
import { TRootState } from "../../../../../store";
import BenPayoutOtpVerification from "../../ben-otp-verification";
import UserDetails from "../../../../../components/partner-info";
import { onoArkAccount } from '../../../../../constants/index'

const Step2 = () => {

    const { selectedBeneficiary, payout } = useSelector((state: TRootState) => ({
        selectedBeneficiary: state.beneficiary.selectedBeneficiary,
        payout: state.payout.payout,
    }))

    return (
        <div className="flex">
            <div
                className="grow-[4] overflow-y-auto card_space_18 px-4 py-2"
                style={{
                    height: "calc(100vh - 8rem)",
                }}
            >
                <div className="flex w-[100%] gap-2 space_18">
                    <div className="w-[50%]">
                        <span className="fs-14 block mb-2">From:</span>
                        <div className="flex border rounded-lg p-2 items-center bg-white">
                            <img src={onoPayout} className="w-12 h-12 br-100" alt="" />
                            <div className="ml-2 flex flex-col">
                                <span className="font-semibold fs-14">
                                    {onoArkAccount?.accountName}
                                </span>
                                <span className="fs-12 color-sub-text">
                                    {maskAccountNumber(onoArkAccount?.accountNumber || '')}
                                </span>
                                <span className="fs-12 color-sub-text">
                                    {onoArkAccount?.bankName}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="w-[50%]">
                        <span className="fs-14 block mb-2">Payable To:</span>
                        <div className="flex border rounded-lg items-center min-h-[95px] p-2 bg-white">
                            <UserDetails
                                profilePic={""}
                                name={selectedBeneficiary?.actHolder ?? ""}
                                partnerMobile={selectedBeneficiary?.mobile?.toString() ?? ""}
                                partnerId={selectedBeneficiary?.email}
                                partnerType={""}
                                partnetAddress={''}
                            />
                        </div>
                    </div>
                </div>

                <div className="border p-4 rounded-lg space_18 bg-white">
                    <div className="flex border-b py-3 w-[100%] gap-2">
                        <div className="w-[30%]">
                            <span className="fs-12 color-sub-text">Date</span>
                            <p className="fs-14 fs-14">
                                {moment().format("DD-MMM-YYYY")}
                            </p>
                        </div>
                        <div className="flex flex-col w-[30%]">
                            <span className="fs-12 color-sub-text">Account Number</span>
                            <p className="fs-14">
                                {maskAccountNumber(selectedBeneficiary?.actNum)}
                            </p>
                        </div>

                        <div className="flex flex-col w-[30%]">
                            <span className="fs-12 color-sub-text">Amount</span>
                            <p className="fs-14 color-red">
                                {getCurrencyNumberWithSymbol(
                                    Number(payout?.amountPaid)
                                )}
                            </p>
                            {/* {numberToWordsWithDecimals(payout?.amountPaid)} */}
                        </div>
                    </div>

                    <div className="flex fs-14 border-b w-[100%] py-3 gap-2">
                        <div className="flex flex-col w-[30%]">
                            <span className="fs-12 color-sub-text">Fund Account ID</span>
                            <p className="fs-14">{selectedBeneficiary?.rzpFa}</p>
                        </div>

                        <div className="flex flex-col w-[30%]">
                            <span className="fs-12 color-sub-text"> Payment Type </span>
                            <p className="fs-14">{payout?.pmtType}</p>
                        </div>

                        <div className="flex flex-col w-[30%]">
                            <span className="fs-12 color-sub-text"> Payment Mode </span>
                            <p className="fs-14">{payout?.pmtMode}</p>
                        </div>
                    </div>

                    <div className="flex fs-14 w-[100%] py-3 gap-2">
                        <div className="flex flex-col w-[30%]">
                            <span className="fs-12 color-sub-text">Reference ID</span>
                            <p className="fs-14">{payout?.referenceId}</p>
                        </div>

                        <div className="flex flex-col w-[70%]">
                            <span className="fs-12 color-sub-text">Comments</span>
                            <p className="fs-14">{payout?.comments}</p>
                        </div>
                    </div>
                </div>

                <div>
                    {<BenPayoutOtpVerification type="TP_PMT" />}
                </div>

            </div>
        </div>
    )
}
export default Step2;